import { Box, HStack, Text, VStack } from '@chakra-ui/react'
import { TbTruckDelivery } from 'react-icons/tb'
import type { PropsWithChildren, ReactElement, ReactNode } from 'react'
import { MdPayment } from 'react-icons/md'
import { useOverridesContext } from 'ui/lib/overrides/hooks'
import { overrideText } from 'ui/lib/overrides'

const PaymentWithDeliveryRow = (
  props: PropsWithChildren<{
    title: ReactNode
    icon: ReactElement
  }>
) => (
  <VStack alignItems="flex-start" w="100%">
    <HStack borderBottomColor="primary" borderBottomWidth="1px" pb={2} w="100%">
      <Box fontSize="lg">{props.icon}</Box>

      <Text fontWeight="medium" textTransform="uppercase">
        {props.title}
      </Text>
    </HStack>

    <VStack alignItems="center" w="100%">
      {props.children}
    </VStack>
  </VStack>
)

export interface PaymentWithDeliveryOverrides {
  checkoutDeliveryStep?: string
  checkoutPaymentStep?: string
}

interface PaymentWithDeliveryProps {
  deliveryComponent: ReactNode
  paymentComponent: ReactNode
}

export const PaymentWithDelivery = ({
  deliveryComponent,
  paymentComponent
}: PaymentWithDeliveryProps) => {
  const overrides = useOverridesContext<keyof PaymentWithDeliveryOverrides>()

  return (
    <VStack alignItems="flex-start" gap={10} w="100%">
      <PaymentWithDeliveryRow
        icon={<TbTruckDelivery />}
        title={`1 / 2 ${overrideText('Leverans', overrides?.checkoutDeliveryStep)}`}
      >
        {deliveryComponent}
      </PaymentWithDeliveryRow>

      <PaymentWithDeliveryRow
        icon={<MdPayment />}
        title={`2 / 2 ${overrideText('Slutför din beställning', overrides?.checkoutPaymentStep)}`}
      >
        {paymentComponent}
      </PaymentWithDeliveryRow>
    </VStack>
  )
}
